import { gql } from "@apollo/client";

export const ANIMALS_FRAGMENT = gql`
  fragment AnimalsFragment on RootQueryToAnimalConnection {
    pageInfo {
      endCursor
      hasNextPage
      total
    }
    edges {
      node {
        id
        title
        uri
        content
        animalDetails {
          animalName
          animalNid
          animalBirthday
          animalSex
          animalUniqueId
          animalWeight
          animalIntakeDate
          animalDescription
          animalPhotoGallery {
            photo
          }
          animalCoverPhoto
        }
        petAttributes {
          nodes {
            slug
            termTaxonomyId
            name
          }
        }
        primaryBreeds {
          nodes {
            slug
            termTaxonomyId
            name
          }
        }
        secondaryBreeds {
          nodes {
            slug
            termTaxonomyId
            name
          }
        }
        weightGroups {
          nodes {
            slug
            termTaxonomyId
            name
          }
        }
        ageGroups {
          nodes {
            slug
            termTaxonomyId
            name
          }
        }
      }
    }
  }
`;
